/* screens/settings/BusinessKnowledgeTab.jsx — подвкладка «База знаний» бизнес-ws.
   Раздел «Заведение» убран из сайдбара — база знаний живёт здесь, рядом с профилем.
   Переиспользует DocumentsTab (screens/restaurant): список+квота — listDocumentsReal(wsId),
   мутации внутри DocumentsTab тоже скоупятся wsId (X-Workspace-Id без переключения
   активного пространства). Deep-link ?doc=ID (легаси /restaurant?doc=) подсвечивает карточку. */

import { QueryBoundary } from '../../components/patterns/States.jsx';
import { hooks } from '../../hooks/index.jsx';
import { listDocumentsReal } from '../../lib/api/index.js';
import { DocumentsTab } from '../restaurant/DocumentsTab.jsx';

  const { useFakeQuery } = hooks;

  function DocsSkeleton() {
    return (
      <div className="kb stack stack-16">
        <span className="skeleton" style={{ height: 96, borderRadius: 'var(--radius-lg)' }} />
        <span className="skeleton" style={{ height: 110, borderRadius: 'var(--radius-lg)' }} />
        <div className="doc-grid">
          {[0, 1, 2].map((i) => <span key={i} className="skeleton" style={{ height: 240, borderRadius: 'var(--radius-lg)' }} />)}
        </div>
      </div>
    );
  }

  function BusinessKnowledgeTab({ wsId }) {
    const q = useFakeQuery('biz-knowledge:' + (wsId == null ? '' : wsId), () => listDocumentsReal(wsId), [wsId]);
    return (
      <QueryBoundary loading={q.loading} error={q.error} onRetry={q.reload} skeleton={<DocsSkeleton />}>
        {q.data && <DocumentsTab quota={q.data.quota} documents={q.data.documents} wsId={wsId} />}
      </QueryBoundary>
    );
  }

export { BusinessKnowledgeTab };
